import { appUrl } from '../runtime'

// The in-app logout is a Next server action; off-host we navigate to core's /logout route
// handler (which clears the shared .weeabets.xyz cookie) and come back to where we were. Used
// as a React form action in NavDropdown, so it may receive a FormData arg, which we ignore.
export async function logout(): Promise<void> {
  const ret = typeof window !== 'undefined' ? window.location.href : ''
  window.location.href = `${appUrl('/logout')}?return=${encodeURIComponent(ret)}`
}
